import { BCMSCurrency, BCMSRecord, DisabledPrompt, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIAmountInput, UIButton, UICheckbox } from "components/ui";
import Classes, { Account, UserAccount } from "model";

import "./styles.css";

export default function BelowThresholdContent(props) {
    const context = useBCMSContext();
    const navigate = useRoute();
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    BCMSRecord.globalControllerFor(Classes, context);

    let account = Account.initAll()[0];
    const balanceThreshold = data.balanceThreshold ? BCMSCurrency.init(data.balanceThreshold) : BCMSCurrency.init(100);
    account = data.account ? data.account : account;
    let selectedUserAccountID = data.selectedUserAccountID ?? "";
    let selectedUserAccountType = data.selectedUserAccountType ?? "";
    const userAccounts = UserAccount.initAll() ?? [];

    console.log(selectedUserAccountID, selectedUserAccountType)

    const onCancel = evt => navigate("/advancedAlerts/currentAlerts");

    const { phones, emails } = userAccounts.reduce((result, { workPhoneNumber, emailAddress, id }) => {
        const phoneIsSelected = id === selectedUserAccountID && selectedUserAccountType === "phone";
        const emailIsSelected = id === selectedUserAccountID && selectedUserAccountType === "email";

        result.phones.push(<UICheckbox label={ workPhoneNumber } dataPoint={ `Add_Alert_User_Account_Phone_${ id }` } value={ phoneIsSelected } />);
        result.emails.push(<UICheckbox label={ emailAddress } dataPoint={ `Add_Alert_User_Account_Email_${ id }` } value={ emailIsSelected } />);

        return result;
    }, { phones: [], emails: [] })

    return (
        <div className="below-threshold-content">
            <p className="page-subtitle">Account Balance Below Threshold</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <div className="flex-container flex-vertical account-details">
                        <p className="account-name">{ account.nickname }</p>
                        <p className="account-number">{ account.number }</p>
                        <p className="account-amount">{ account.currentBalance.format() }</p>
                    </div>
                </FormRowView>

                <FormRowView text="Amount *">
                    <UIAmountInput value={ balanceThreshold.format().slice(1) } />
                </FormRowView>

                <FormRowView text="Recipients *">
                    <div className="flex-container flex-vertical">
                        { emails }
                        { phones }
                    </div>
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="secondary-button" text="Cancel" dataPoint="Below_Threshold_Cancel_Button" onClick={ onCancel } />
                    
                    <DisabledPrompt>
                        <UIButton className="primary-button" dataPoint="Below_Threshold_Update_Button" text="Update" />
                        <UIButton className="primary-button" dataPoint="Below_Threshold_Delete_Button" text="Delete" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});